__turbopack_context__.v({
  "directions": "HowToGetThere-module-scss-module__LZrG1a__directions",
  "icon": "HowToGetThere-module-scss-module__LZrG1a__icon",
  "list": "HowToGetThere-module-scss-module__LZrG1a__list",
  "text": "HowToGetThere-module-scss-module__LZrG1a__text",
  "title": "HowToGetThere-module-scss-module__LZrG1a__title",
});
